// assets
import { 
  DashboardOutlined, 
  BarChartOutlined, 
  LineChartOutlined, 
  PieChartOutlined,
  TableOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined,
  TableOutlined,
  FileTextOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Spectra',
  titleKey: 'menu.groups.spectra',
  titleVariant: 'h6',
  titleSx: { fontSize: 15, fontWeight: 700 },
  type: 'group',
  icon: icons.LineChartOutlined,

  children: [
    {
      id: 'spectraviewer',
      title: 'Spectra Viewer',
      titleKey: 'menu.items.spectraViewer',
      type: 'item',
      icon: icons.LineChartOutlined,
      url: '/spectra/spectraviewer',
      breadcrumbs: false
    }
  ]
};

export default dashboard;

